<template>
  <div>
    <div v-for="location in locations" :key="location.slug" class="location">
      <router-link to="/info"><h2>{{location.name}}</h2></router-link>
      <v-row class="brews">
      <template v-for="brew in breweries">
        <v-col  :key="brew.id" v-if="brew.location === location.slug" class="d-flex child-flex" cols="4">

          <router-link :to="{ name: 'Brew', params: { id: brew.id } }">
            <img :src="brew.checked === false ? brew.greyLogoURL : brew.logoURL" aspect-ratio="1"
              style="border-radius:5px;background:black;width:80px;height:80px;" /></router-link>
        </v-col>
      </template>
    </v-row>    
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// import { results } from '@/data.js'
export default {
  mounted () {
    this.$store.dispatch('brew/getBreweries')
  },

  computed: {
    ...mapGetters("brew", ["breweries"]),
    ...mapGetters("location", ["locations"]),
  }
}
</script>

<style>
.location {
  min-height:100px;
  margin-top: 1.5rem;
  border-bottom:2px solid;
  border-color: rgba(255, 255, 255, 0.12);
}
.location a {
  text-decoration:none;
}
.brews {
  min-height:100px;
}
</style>